import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useMediaQuery } from 'react-responsive';
import { FileUploader } from 'react-drag-drop-files';
import Stack from '@mui/material/Stack';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LensIcon from '@mui/icons-material/Lens';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FileFrame from '@IssueConsoleFunctionalDisplay/FileFrame';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import FieldService from '@Helpers/URLHelpers/FieldService';
import ErrorHandler from '@Root/ErrorHandler';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import PhoneInput from 'react-phone-input-2'
import { Emoji } from 'emoji-picker-react';
import 'react-phone-input-2/lib/material.css'
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import './FieldEntry.scss';

export default function FieldEntry(props) {

    const [ratingRange, setRatingRange] = useState(5);
    const [ratingType, setRatingType] = useState('');
    const [required, setRequired] = useState(false);
    const [ratingScaleIcon, setRatingScaleIcon] = useState('star');
    const [ratingInitialLabel, setRatingInitialLabel] = useState('');
    const [ratingFinalLabel, setRatingFinalLabel] = useState('');
    const [informationFieldEditorState, setInformationFieldEditorState] = useState(EditorState.createEmpty());
    const [fieldTextSize, setFieldTextSize] = useState(0);
    const [multiSelectChecked, setMultiSelectChecked] = useState([]);
    const [rules, setRules] = useState([]);
    const [fieldValue, setFieldValue] = useState();
    const [totalFileSize, setTotalFileSize] = useState(0);
    const [largeFileError, setLargeFileError] = useState(false);
    const [options, setOptions] = useState([]);
    const [refresh, setRefresh] = useState(false);
    useMediaQuery({ maxWidth : 768});
    new ErrorHandler();
    new KaiziqResolveConnectionService();
    new FieldPageService();
    new FieldService();
    const className = 'fieldEntry';

    const HeartStyledRating = styled(Rating)({
      '& .MuiRating-iconFilled': {
        color: '#ff6d75',
      },
      '& .MuiRating-iconHover': {
        color: '#ff3d47',
      },
    });

    const CircleStyledRating = styled(Rating)({
      '& .MuiRating-iconFilled': {
        color: '#2784B9d6',
      },
      '& .MuiRating-iconHover': {
        color: '#2784B9',
      },
    });

    useEffect(() => {
        let rulesObj = [];
        let optionsObj = [];
        let isDefaultFieldEntryValue = true;
        if(props.fieldEntryMap[props.field.id]) {
            setFieldValue(props.fieldEntryMap[props.field.id]);
            isDefaultFieldEntryValue = false;
        } else {
            setFieldValue([]);
            isDefaultFieldEntryValue = true;
        }
        if(!!props.field?.rules) {
            rulesObj = JSON.parse(props.field?.rules);
            setRules(rulesObj);
        }
        if(!!props.field?.options) {
            optionsObj = JSON.parse(props.field?.options);
            setOptions(optionsObj);
        }
        if(props.field?.type == 'information') {
            let ruleIndex = rulesObj?.findIndex((rule) => rule.type === 'text');
            if(!!rulesObj[ruleIndex].value) {
                setInformationFieldEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(rulesObj[ruleIndex].value))));
            } else {
                const contentBlock = htmlToDraft('');
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const editorStateObj = EditorState.createWithContent(contentState);
                    setInformationFieldEditorState(editorStateObj);
                }
            }
        }
        if(props.field?.type == 'multiChoice') {
            if(isDefaultFieldEntryValue) setFieldValue(optionsObj?.find((option) => option.id === rulesObj.find((rule) => rule.type === 'default')?.value))
        }
        if(props.field?.type == 'multiSelect') {
            if(isDefaultFieldEntryValue) {
                let value = optionsObj.find((option) => option.id === rulesObj.find((rule)=> rule.type === 'default'));
                setFieldValue(!!value ? value : '');
            }
        }
        if(props.field?.type === 'number') {
            if(isDefaultFieldEntryValue) {
                let findValue = rulesObj?.find((rule) => rule.type === 'default')?.value;
                setFieldValue(!!findValue ? findValue : {});
            } else {
                setFieldValue({});
            }
        }
        if(props.field?.type === 'phoneNumber') {
            setFieldValue('');
        }
        if(props.field?.type === 'file') {
            if(isDefaultFieldEntryValue) setFieldValue({});
        }
        if(props.field?.type === 'duration') {
            let durationObj = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }
            if(isDefaultFieldEntryValue) setFieldValue(durationObj);
        }
        if(props.field?.type == 'rating') {
            setRatingRange(rulesObj.find((rule) => rule.type === 'width')?.value)
            setRatingType(rulesObj.find((rule) => rule.type === 'ratingType')?.value)
            setRatingScaleIcon(rulesObj.find((rule) => rule.type === 'scaleIcon')?.value)
            setRatingFinalLabel(rulesObj.find((rule) => rule.type === 'ratingFinalLabel')?.value)
            setRatingInitialLabel(rulesObj.find((rule) => rule.type === 'ratingInitialLabel')?.value)
        }
        setRequired(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'required')?.value);
    }, [props])

    const handleTextFieldChange = (e) => {
        let sanitizedText = e.target.value;
        setFieldTextSize(sanitizedText.length);
        setFieldValue(sanitizedText);
        props.handleFieldEntryChange(props.field.id, sanitizedText);
        props.checkIsNextEnabled();
    }

    const handleDurationDaysFieldChange = (e) => {
        let sanitizedDays = e.target.value;
        let fieldValueObj = fieldValue;
        fieldValueObj.days = sanitizedDays;
        setFieldValue(fieldValueObj)
        props.handleFieldEntryChange(props.field.id, fieldValueObj);
        props.checkIsNextEnabled();
        setRefresh(!refresh);
    }

    const handleDurationHoursFieldChange = (e) => {
        let sanitizedHours = e.target.value;
        if(Number(sanitizedHours) > 24) sanitizedHours = '24';
        let fieldValueObj = fieldValue;
        fieldValueObj.hours = sanitizedHours;
        setFieldValue(fieldValueObj)
        props.handleFieldEntryChange(props.field.id, fieldValueObj);
        props.checkIsNextEnabled();
        setRefresh(!refresh);
    }

    const handleDurationMinutesFieldChange = (e) => {
        let sanitizedMinutes = e.target.value;
        if(Number(sanitizedMinutes) > 60) sanitizedMinutes = '60';
        let fieldValueObj = fieldValue;
        fieldValueObj.minutes = sanitizedMinutes;
        setFieldValue(fieldValueObj)
        props.handleFieldEntryChange(props.field.id, fieldValueObj);
        props.checkIsNextEnabled();
        setRefresh(!refresh);
    }

    const handleDurationSecondsFieldChange = (e) => {
        let sanitizedSeconds = e.target.value;
        if(Number(sanitizedSeconds) > 60) sanitizedSeconds = '60';
        let fieldValueObj = fieldValue;
        fieldValueObj.seconds = sanitizedSeconds;
        setFieldValue(fieldValueObj)
        props.handleFieldEntryChange(props.field.id, fieldValueObj);
        props.checkIsNextEnabled();
        setRefresh(!refresh);
    }

    const handleNumberFieldChange = (e) => {
        let number = e.target.value;
        number = Number(number).toString();
        if(number === '') number = '0';
        if(!((!!JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMin')?.value &&
                Number(number) < Number(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMin')?.value)) ||
           (!!JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMax')?.value &&
                Number(number) > Number(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMax')?.value)))) {
            props.handleFieldEntryChange(props.field.id, number);
            props.checkIsNextEnabled();
        }
        setFieldValue(number);
    }

    const handleMultiSelectOptionClick = (id) => {
        let multiSelectCheckedList = multiSelectChecked;
        if(multiSelectChecked.some((multiSelectId) => multiSelectId === id)) {
            multiSelectCheckedList = multiSelectCheckedList.filter((multiSelectId) => multiSelectId !== id);
        } else {
            multiSelectCheckedList.push(id);
        }
        setMultiSelectChecked(multiSelectCheckedList);
        props.handleFieldEntryChange(props.field.id, multiSelectCheckedList);
        props.checkIsNextEnabled();
        setRefresh(!refresh);
    }

    const handleDateChange = (date) => {
        setFieldValue(date.$d.valueOf());
        props.handleFieldEntryChange(props.field.id, date.$d.valueOf());
        props.checkIsNextEnabled();
    }

    const handleMultiChoiceValueChange = (event) => {
        setFieldValue(event.target.value);
        props.handleFieldEntryChange(props.field.id, event.target.value);
        props.checkIsNextEnabled();
    }

    const handleRatingValueChange = (event) => {
        setFieldValue(event.target.value);
        props.handleFieldEntryChange(props.field.id, event.target.value);
        props.checkIsNextEnabled();
    }

    const handlePhoneNumberChange = async(number) => {
        setFieldValue(number)
        props.handleFieldEntryChange(props.field.id, number);
        props.checkIsNextEnabled();
    }

    const handleFileChange = async (file) => {
        if(!!file) {
            let fileSize = file.size/(1024*1024);
            if(fileSize + totalFileSize > 5){
                setLargeFileError(true);
            } else {
                setTotalFileSize(fileSize + totalFileSize);
                setLargeFileError(false);
                const url = await convertFileToBase64(file);
                let filesObj = fieldValue;
                let newFileObj = {
                    file: url,
                    fileName: file.name,
                    fileSize: fileSize,
                    fileType: file.type
                }
                filesObj[file.name] = newFileObj;
                setFieldValue(filesObj);
                props.handleFieldEntryChange(props.field.id, filesObj);
                props.checkIsNextEnabled();
                setRefresh(!refresh);
            }
        }
    };

    const isFieldEntryInvalid = () => {
        let fieldEntryInvalid = false;
        if(required && props.isNextHovered && (!props.fieldEntryMap || !props.fieldEntryMap[props.field.id])) {
            fieldEntryInvalid = true;
        }
        return fieldEntryInvalid;
    }

    const convertFileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const deleteFile = (fileName) => {
        let filesObj = fieldValue;
        delete(filesObj[fileName]);
        setFieldValue(filesObj);
        setRefresh(!refresh);
    }

    return (
        <div className={className}
            style={(!!props.kaiziqResolveConnection && Object.keys(props.kaiziqResolveConnection) != 0) ? props.fieldBackgroundStyle : {}}>
            <div className={className + '__inner width-wfa'}>
                <div className={className + '__inner__field width-wfa flex-column-flex-start-2vh-gap '}>
                    <h2 className={className + '__inner__field__title semi-bold-text width-wfa standard-text-weight ' +
                        (isFieldEntryInvalid() ? 'red-text' : '')}>
                        {props?.field?.title}
                        {
                            (!!props.field?.rules && props.field?.type !== 'information') ?
                                required ?
                                    '*'
                                :
                                    ''
                            :
                                ''
                        }
                    </h2>
                    {
                        props.field?.type == 'text' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <TextField
                                    placeholder={JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'default')?.value}
                                    className={className + '__inner__field__input__textField width-wfa'}
                                    type='text'
                                    onChange={handleTextFieldChange}
                                    value={fieldValue}
                                    inputProps={{ maxLength: JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'width')?.value ?? 250 }}
                                    maxRows={(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'width')?.value/250) + 1}
                                    minRows={JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'width')?.value/250}
                                    multiline
                                    variant='outlined'
                                    required/>
                                <div className={className + '__inner__field__input__size flex-column-flex-end-2vh-gap semi-bold-text width-wfa '
                                    + ((fieldTextSize >= JSON.parse(props.field?.rules).find((rule) => rule.type === 'width')?.value) ? ' red-text' : '')}>
                                    {fieldTextSize}/{JSON.parse(props.field?.rules).find((rule) => rule.type === 'width')?.value}
                                </div>
                            </div>
                    }
                    {
                        props.field?.type == 'number' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <div className={className + '__inner__field__input__value  flex-column-flex-start-1vh-gap'}
                                    style={{width: ((JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'digitWidth')?.value
                                        ? ((JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'digitWidth')?.value + 5) < 30 ?
                                            (JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'digitWidth')?.value + 5) : 15)
                                        : '15') + 'rem')}}>
                                    <TextField
                                        className={className + '__inner__body__field__number__value__textField'}
                                        type='number'
                                        size='small'
                                        value={fieldValue}
                                        onChange={handleNumberFieldChange}
                                        placeholder={JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'default')?.value}
                                        maxRows='1'
                                        variant='outlined'/>
                                </div>
                                <div className={className + '__inner__field__input__range ' +
                                    (((!!JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMin')?.value &&
                                        (!!fieldValue ? Number(fieldValue) : 0) < Number(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMin')?.value)) ||
                                   (!!JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMax')?.value &&
                                        (!!fieldValue ? Number(fieldValue) : 0) > Number(JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMax')?.value))) ? ' red-text' :'')}>
                                    {JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMin')?.value ?? 0}:{JSON.parse(props.field?.rules)?.find((rule) => rule.type === 'rangeMax')?.value ?? 'N/A'}
                                </div>
                            </div>
                    }
                    {
                        props.field?.type == 'date' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <div className={className + '__inner__field__input__value flex-column-center'}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={3}>
                                            {
                                                rules?.find((rule) => rule.type === 'timeSelect')?.value ?
                                                    <MobileDateTimePicker
                                                      className={className + '__inner__field__input__value__input'}
                                                      value={fieldValue ? dayjs(fieldValue) : null}
                                                      onChange={handleDateChange}
                                                      label="Pick Date"
                                                      renderInput={(params) => <TextField variant="outlined" {...params} />}
                                                    />
                                                :
                                                    <DesktopDatePicker
                                                        inputFormat="DD/MM/YYYY"
                                                        value={fieldValue ? dayjs(fieldValue) : null}
                                                        onChange={handleDateChange}
                                                        renderInput={(params) => <TextField variant="outlined" {...params} />}
                                                    />
                                            }
                                        </Stack>
                                    </LocalizationProvider>
                                </div>
                            </div>
                    }
                    {
                        props.field?.type == 'information' &&
                            <div className={className + '__inner__field__value width-wfa'}
                                dangerouslySetInnerHTML={{__html: draftToHtml(convertToRaw(informationFieldEditorState.getCurrentContent()))}}/>
                    }
                    {
                        props.field?.type == 'file' &&
                            <div className={className + '__inner__field__value width-wfa'}>
                                <div className={className + '__inner__field__value__fileDrop width-wfa'}>
                                    <FileUploader label='Upload or drop a file right here. Max Size 5MB !'
                                        handleChange={handleFileChange}/>
                                </div>
                                <div className={'standard-text-small standard-text-weight ' + (totalFileSize >= 1.9 ? 'red-text': '')}>
                                    {!!totalFileSize ? totalFileSize.toFixed(2) : 0}/5MB
                                </div>
                                {
                                    largeFileError &&
                                    <p className='standard-text-small standard-text-weight alert-text'> Total File size too Large!</p>
                                }
                                <div className={className + '__inner__field__value__fileList flex-row-center-1vw-gap'}>
                                    {
                                        !!fieldValue && Object.keys(fieldValue).map((fileName) => (
                                            <div className={className + '__inner__field__value__fileList__file flex-row-center-1vw-gap'}>
                                                <FileFrame
                                                    file={fieldValue[fileName]}
                                                    fileType={fieldValue[fileName].fileType}
                                                    showClose={true}
                                                    deleteFile={deleteFile}/>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                    }
                    {
                        props.field?.type === 'multiChoice' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <FormControl>
                                    <RadioGroup
                                        value={!!fieldValue ? fieldValue : '0'}
                                        onChange={handleMultiChoiceValueChange}>
                                        {
                                            options?.map((option) =>
                                                <FormControlLabel
                                                    value={JSON.stringify(option.id)}
                                                    control={<Radio />} label={
                                                    <div className={className + '__inner__body__field__multiChoice__value__select__option flex-row-center-1vw-gap'}>
                                                        <div className={className + '__inner__body__field__multiChoice__value__select__option indicator-box'}
                                                            style={{background: option.color}}/>
                                                        {option.title}
                                                    </div>
                                                } />
                                            )
                                        }
                                    </RadioGroup>
                                </FormControl>
                            </div>
                    }
                    {
                        props.field?.type === 'multiSelect' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <FormControl>
                                    <FormGroup>
                                        {
                                            options?.map((option) =>
                                                <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={multiSelectChecked?.some((multiSelectId) => multiSelectId === option.id)}
                                                        onChange={() => handleMultiSelectOptionClick(option.id)} name={option.id} />
                                                    }
                                                    label={option.title}/>
                                            )
                                        }
                                    </FormGroup>
                                </FormControl>
                            </div>
                    }
                    {
                        props.field?.type == 'duration' &&
                            <div className={className + '__inner__field__input width-wfa flex-column-flex-start-1vh-gap'}>
                                <div className={className + '__inner__field__input__duration flex-row-center-1vw-gap'}>
                                    <TextField
                                        className={className + '__inner__field__input__duration__textField'}
                                        type='number'
                                        size='small'
                                        variant='outlined'
                                        value={fieldValue?.days}
                                        onChange={handleDurationDaysFieldChange}
                                        InputProps={{ inputProps: { min: 0} }}
                                        required/>
                                    <TextField
                                        className={className + '__inner__field__input__duration__textField'}
                                        type='number'
                                        size='small'
                                        value={fieldValue?.hours}
                                        onChange={handleDurationHoursFieldChange}
                                        InputProps={{ inputProps: { min: 0, max: 24 } }}
                                        variant='outlined'
                                        required/>
                                    <TextField
                                        className={className + '__inner__field__input__duration__textField'}
                                        type='number'
                                        size='small'
                                        value={fieldValue?.minutes}
                                        onChange={handleDurationMinutesFieldChange}
                                        InputProps={{ inputProps: { min: 0, max: 60 } }}
                                        variant='outlined'
                                        required/>
                                    <TextField
                                        className={className + '__inner__field__input__duration__textField'}
                                        type='number'
                                        size='small'
                                        value={fieldValue?.seconds}
                                        onChange={handleDurationSecondsFieldChange}
                                        InputProps={{ inputProps: { min: 0, max: 60 } }}
                                        variant='outlined'
                                        required/>
                                </div>
                                <div className={className + '__inner__field__input__duration grey-text flex-row-center-1vw-gap'}>
                                    <div className={className + '__inner__field__input__duration__headers '}>
                                        Days
                                    </div>
                                    <div className={className + '__inner__field__input__duration__headers '}>
                                        Hours
                                    </div>
                                    <div className={className + '__inner__field__input__duration__headers '}>
                                        Minutes
                                    </div>
                                    <div className={className + '__inner__field__input__duration__headers '}>
                                        Seconds
                                    </div>
                                </div>
                            </div>
                    }
                    {
                        props.field?.type == 'phoneNumber' &&
                            <div className={className + '__inner__field__input flex-column-center-1vh-gap'}>
                                <PhoneInput
                                    country='in'
                                    onChange={handlePhoneNumberChange}
                                    value={''}
                                    placeholder='Enter phone number'/>
                            </div>
                    }
                    {
                        props.field?.type == 'rating' &&
                            <div className={className + '__inner__field__input flex-row-center-1vw-gap'}>
                                {
                                    ratingType === 'select' &&
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                value={!!fieldValue ? fieldValue : '0'}
                                                onChange={handleRatingValueChange}>
                                                {
                                                    options?.map((option) =>
                                                        <FormControlLabel value={JSON.stringify(option.id)} labelPlacement='bottom' control={<Radio />} label={
                                                            <div className={className + '__inner__body__field__multiChoice__value__select__option flex-row-center-1vw-gap'}>
                                                                {
                                                                    option.iconType === 'text' ?
                                                                        option.title
                                                                    :
                                                                        <Emoji
                                                                            unified={option?.iconValue?.unified}
                                                                            size={25}/>
                                                                }
                                                            </div>
                                                        } />
                                                    )
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                }
                                {
                                    ratingType === 'range' &&
                                        <div className={className + '__inner__field__input__range flex-row-center-1vw-gap'}>
                                            <div className={className + '__inner__field__input__range__initial standard-text-semi-large semi-bold-text'}>
                                                {ratingInitialLabel}
                                            </div>
                                            <FormControl>
                                            <RadioGroup
                                                row
                                                value={!!fieldValue ? fieldValue : '0'}
                                                onChange={handleRatingValueChange}>
                                                {
                                                    options?.map((option) =>
                                                        <FormControlLabel value={JSON.stringify(option.id)} labelPlacement='bottom' control={<Radio />} label={option.value} />
                                                    )
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                            <div className={className + '__inner__field__input__range__final standard-text-semi-large semi-bold-text'}>
                                                {ratingFinalLabel}
                                            </div>
                                        </div>
                                }
                                {
                                    ratingType === 'scale' &&
                                        <div className={className + '__inner__field__input__range flex-row-center-1vw-gap'}>
                                            {
                                                ratingScaleIcon === 'star' &&
                                                    <Rating
                                                        defaultValue={0}
                                                        value={!!fieldValue ? fieldValue : '0'}
                                                        max={Number(ratingRange)}
                                                        onChange={handleRatingValueChange}
                                                        size='large'/>
                                            }
                                            {
                                                ratingScaleIcon === 'heart' &&
                                                    <HeartStyledRating
                                                        defaultValue={0}
                                                        value={!!fieldValue ? fieldValue : '0'}
                                                        getLabelText={(value: number) => `${value} Heart${value !== 1 ? 's' : ''}`}
                                                        max={Number(ratingRange)}
                                                        icon={<FavoriteIcon fontSize='inherit' />}
                                                        size='large'
                                                        onChange={handleRatingValueChange}
                                                        emptyIcon={<FavoriteBorderIcon fontSize='inherit' />}/>
                                            }
                                            {
                                                ratingScaleIcon === 'circle' &&
                                                    <CircleStyledRating
                                                        defaultValue={0}
                                                        value={!!fieldValue ? fieldValue : '0'}
                                                        getLabelText={(value: number) => `${value} Heart${value !== 1 ? 's' : ''}`}
                                                        max={Number(ratingRange)}
                                                        icon={<LensIcon fontSize='inherit' />}
                                                        size='large'
                                                        onChange={handleRatingValueChange}
                                                        emptyIcon={<RadioButtonUncheckedIcon fontSize='inherit' />}/>
                                            }
                                        </div>
                                }
                            </div>
                    }
                </div>
                <div className={className + '__inner__bottom width-wfa flex-row-center-space-between'}>
                    <div/>
                    <div className={className + '__inner__bottom__t1 grey-text bold-text'}>
                        {props.index + 1}/{props.fieldPageFieldIdList.length}
                    </div>
                </div>
            </div>
        </div>
    )
}
